const fmt = new Intl.NumberFormat("sv-SE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatAmount(n: number): string {
  if (n === 0 || Number.isNaN(n)) return "0,00 kr";
  const abs = fmt.format(Math.abs(n));
  return n < 0 ? `−${abs} kr` : `${abs} kr`;
}

export function formatAmountBare(n: number): string {
  if (n === 0 || Number.isNaN(n)) return "";
  return formatAmount(n).replace(/\s?kr$/, "");
}

export function parseAmount(s: string): number {
  if (typeof s !== "string") return NaN;
  const cleaned = s
    .replace(/kr/gi, "")
    .replace(/\s/g, "")
    .replace(/−/g, "-")
    .replace(/,/g, ".");
  return parseFloat(cleaned);
}

import { getISOWeek, parseISO } from "date-fns";

export function isoWeek(dateStr: string): number {
  const d = parseISO(dateStr);
  if (isNaN(d.getTime())) return 0;
  return getISOWeek(d);
}

export function todayISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function newId(): string {
  return (
    "r_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
  );
}

export const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

type DatedState = {
  rows: { dueDate: string }[];
  fixedCosts: { startDate: string | null; endDate: string | null }[];
};

export function hasInvalidDates(state: DatedState): boolean {
  const invalid = (d: string | null) => d !== null && !ISO_DATE.test(d);
  return (
    state.rows.some((r) => invalid(r.dueDate)) ||
    state.fixedCosts.some((c) => invalid(c.startDate) || invalid(c.endDate))
  );
}
